<div class="h-full overflow-y-auto overflow-x-hidden">
	<app-header-views
		[title]="translateGroups.title"
		[textButton]="translateGroups.buttonNew"
		(actionButton)="openDialogGroups()"
		[hoverButton]="
			groupSelected!.pk ? translateGroups.textHoverSubGroups : translateGroups.textHoverGroups
		"
	></app-header-views>
	<app-modal-alert
		*ngIf="openAlert"
		[value]="valueModalDelete"
		[elementsDelete]="elementsDelete"
		[nameModal]="'modalAlertDeleteElement'"
		(closeModalAlert)="closeModalAlert($event)"
	></app-modal-alert>
	<app-breadcrumb
		[home]="{ text: translateGroups.title, id: ['groupPrincipal'] }"
		[nameElements]="breadcrumb"
		(positionBreadcumbd)="positionBreadcrumb($event)"
	></app-breadcrumb>
	<div *ngIf="viewGroups">
		<div *ngIf="!loading">
			<div class="contet-view-groups" *ngIf="groups.length > 0">
				<div class="cards-groups" *ngFor="let group of groups | searchClient : searchClient | sort">
					<div class="card-groups">
						<div class="settings" (click)="menu.toggle($event)">
							<mat-icon>settings</mat-icon>
							<p-menu #menu [popup]="true" [model]="group.items"></p-menu>
						</div>
						<img
							class="img-card"
							[src]="group.picture"
							imgNotFound
							alt=""
							(click)="selectGroupView(group)"
						/>
					</div>
					<div class="title-card" (click)="selectGroupView(group)">
						<span>{{ group.name }} </span>
					</div>
				</div>
			</div>
			<div
				*ngIf="groups.length === 0"
				class="content-view-not-clients flex h-[calc(100vh-142px)] justify-center items-center"
			>
				<div class="not-groups">
					<img src="../../../../assets/icon/line.svg" alt="" />
					<div class="text">
						<span>
							{{ translateGroups.notSelectesGroup }}
							<span class="button">
								<mat-icon>add</mat-icon>
								<span> {{ translateGroups.buttonNew }} </span>
							</span>
						</span>
					</div>
				</div>
			</div>
		</div>
		<div class="w-full justify-center" *ngIf="loading">
			<app-loading-spinner *ngIf="loading"></app-loading-spinner>
		</div>
	</div>

	<div class="content-view" *ngIf="!viewGroups">
		<app-sub-sidebar
			[tamMinWidhtSibSidebar]="210"
			[back]="isSubGroup"
			[tamWidhtSibSidebar]="250"
			[tamHeightSibSidebar]="196"
			(searchText)="searchSidebar($event)"
			(actionBack)="btnBack($event)"
		>
			<div class="cards" *ngIf="!loading">
				<div *ngIf="groups.length > 0">
					<div
						[matTooltip]="group.name"
						[matTooltipPosition]="'right'"
						*ngFor="let group of groups | searchClient : searchClient | sort"
						class="card-group"
						[ngClass]="{ 'card-selected': this.groupSelected.sk === group.sk }"
					>
						<div class="settings relative w-full flex items-center h-[20px]">
							<div class="w-full cursor-pointer" (click)="selectGroupView(group)">
								<p class="my-0">
									<span class="users">{{ group.users }} {{ translateGroups.textUsers }}</span>
								</p>
							</div>
							<mat-icon class="icon-material icon-setting" (click)="menu.toggle($event)">
								settings
							</mat-icon>
							<p-menu #menu [popup]="true" [model]="group.items"></p-menu>
						</div>
						<div
							class="flex justify-center items-center h-[100px] cursor-pointer w-full"
							(click)="selectGroupView(group)"
						>
							<img
								imgNotFound
								src="{{ group.picture }}"
								class="w-[130px] h-[90px] object-contain"
							/>
						</div>
						<div class="content-card w-full flex flex-row">
							<div
								class="content-card flex text-center justify-center cursor-pointer w-full"
								(click)="selectGroupView(group)"
							>
								<p class="name" [pTooltip]="group.name">
									{{ group.name }}
								</p>
							</div>
							<div
								class="flex justify-end w-[20px] h-[20px]"
								*ngIf="group.subGroups"
								(click)="selectGroupView(group)"
							>
								<mat-icon class="text-primary-color text-xl text-end cursor-pointer">
									chevron_right
								</mat-icon>
							</div>
						</div>
					</div>
				</div>
				<div
					*ngIf="groups.length === 0"
					class="flex justify-center items-center"
					style="height: calc(100vh - 226px)"
				>
					<div class="not-groups">
						<img src="../../../../assets/icon/line.svg" alt="" />
						<div class="text">
							<span>
								{{ translateGroups.notSubGroups }}
								<span class="button">
									<mat-icon>add</mat-icon>
									<span> {{ translateGroups.buttonNew }} </span>
								</span>
							</span>
						</div>
					</div>
				</div>
			</div>
			<div class="cards" *ngIf="loading">
				<app-loading-spinner *ngIf="loading"></app-loading-spinner>
			</div>
		</app-sub-sidebar>
		<div class="view-selected">
			<div class="not-selected h-full" *ngIf="!groupSelected.sk">
				<div class="content-not-selected h-full flex items-center flex-col justify-center">
					<img src="../../../../assets/icon/notFile.svg" alt="" />
					<span class="notFount"> {{ translateGroups.notSelectesGroup }} </span>
				</div>
			</div>
			<div class="info-groups h-full flex flex-col justify-between" *ngIf="groupSelected.sk">
				<div
					class="header-info flex justify-between h-[95px] border-b border-b-neutral-color-c pr-2 items-center"
				>
					<div class="title-selected flex flex-col justify-between pl-2.5">
						<span class="text-3xl font-lato font-bold text-complementary-color-a">{{
							groupSelected.name
						}}</span>
						<span class="text-xs font-lato font-normal text-complementary-color-a"
							>ID:{{ groupSelected.sk.split(':')[0] }}
						</span>
					</div>
					<div class="tabs">
						<app-tabs [tabs]="tabs" [view]="viewSelect" (active)="tabSelect($event)"></app-tabs>
					</div>
				</div>
				<div class="body h-full overflow-x-hidden">
					<app-general
						[isSubGroup]="levelGroup.length > 1 ? true : false"
						[group]="groupSelected"
						[loading]="loadingGeneral"
						*ngIf="viewSelect === '1'"
					></app-general>
					<app-status
						[loading]="loadingGeneral"
						[group]="this.groupSelected"
						*ngIf="viewSelect === '2'"
					>
					</app-status>
					<app-users-groups
						[loading]="loadingGeneral"
						[group]="this.groupSelected"
						*ngIf="viewSelect === '3'"
					></app-users-groups>
					<app-security
						[loading]="loadingGeneral"
						[group]="this.groupSelected"
						*ngIf="viewSelect === '4'"
					></app-security>
					<app-profile *ngIf="viewSelect === '5'"></app-profile>
				</div>
			</div>
		</div>
	</div>
</div>
